import React from 'react';
import { useParams } from 'react-router-dom';
import { getLcn } from '~/utils/labeled-classnames';
import { useFetchChart } from '../../api/charts_queries';
import SpinnerTw from '~/components/SpinnerTw';
import InfoBox from '~/shared/components/info_boxes/InfoBox';
import ChartShow from '../charts/show/ChartShow';
import ChartEdit from '../charts/edit/ChartEdit';

export default function ChartPage() {
  let { chartId: chartIdParam, action } = useParams();

  const chartId = parseInt(chartIdParam || '0');

  const fetchChartQuery = useFetchChart(chartId);

  const lcn = getLcn({
    chartPage: ''
  });

  if (fetchChartQuery.isLoading) {
    return <SpinnerTw size='lg' />;
  }

  if (fetchChartQuery.isError) {
    return <InfoBox type='error'>
      There was an error loading the chart. Please try again later.
    </InfoBox>;
  }

  if (!fetchChartQuery.data) {
    return <InfoBox type='error'>
      Chart not found.
    </InfoBox>;
  }

  const chart = fetchChartQuery.data;

  return (
    <div className={lcn.chartPage}>
      {action === 'show' &&
        <ChartShow chart={chart} />
      }
      {action === 'edit' &&
        <ChartEdit chart={chart} />
      }
    </div>
  );
}; 